import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import { Label } from 'src/types'

export const LABELS_ENDPOINT = 'labels_type'
export const LABELS_QUERY_KEY = 'labels'

interface LabelsQueryParams {
  id?: Id[]
  verticalId?: Id | Id[]
}

const generateQueriesConfig: GenerateQueriesArgs<Label, LabelsQueryParams> = {
  endpoint: LABELS_ENDPOINT,
  queryKey: LABELS_QUERY_KEY,
  useAllEntitiesQueryArgs: {
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
    },
  },
}

export const { useAllEntitiesQuery: useLabelsQuery } = generateQueries(generateQueriesConfig)
